import { useEffect, useState } from "react";
import "./gridEvent.css"
import { useTranslation } from "react-i18next";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function StockItem ( props ) {
    const { setSelectStockItem } = props;
    const [, setApi] = useState();
    const [grid, setGrid] = useState();
    const [, setSelectGrid] = useState();

    const {t} = useTranslation();

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelectGrid(grid.selectedItems[0]);
                        setSelectStockItem(grid.selectedItems[0]);
                    } else {
                        setSelectGrid(undefined);
                        setSelectStockItem(undefined);
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelectGrid(grid.selectedItems[0]);
                        setSelectStockItem(grid.selectedItems[0]);
                    } else {
                        setSelectGrid(undefined);
                        setSelectStockItem(undefined);
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);
    
    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    return <BasicCrudScreenType 
        id="stockItem"
        table="StockItemView" 
        view="StockItemView"
        onApiInitialized={onApiInitialized}
        onInitialized={onInitialized}
        headerTitle={t("tableName.stockItem")}
        noCreate
        noEdit
        noDelete
        noExcel
    />;
}

export default StockItem;
